import React from 'react';
// import './Footer.css';
import logo from '../assets/image/logo.png'

const Footer = () => {
    return (
        <footer>
            <div className="footer-area footer-bg">
                <div className="container">
                    <div className="footer-top footer-padding">

                        {/* All Columns in one row (Responsive) */}
                        <div
                            className="row single-footer-row"
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap', // <-- enables mobile responsiveness
                                justifyContent: 'space-between',
                                gap: '20px 0' // <-- spacing between rows on mobile
                            }}
                        >
                            <div
                                className="col-xl-2 col-lg-2 col-md-4 col-sm-6"
                                style={{ flex: '1 1 250px', minWidth: '250px' }}
                            >
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-tittle">
                                        <h4>KMCA</h4>
                                        <ul>
                                            <li><a href="about.html">About Us</a></li>
                                            <li><a href="gallery.html">Gallery</a></li>
                                            <li><a href="contact.html">Contact</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="col-xl-3 col-lg-3 col-md-4 col-sm-6"
                                style={{ flex: '1 1 250px', minWidth: '250px' }}
                            >
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-tittle">
                                        <h4>Our Courses</h4>
                                        <ul>
                                            <li><a href="thebeginnercourse.html">The Beginner Course</a></li>
                                            <li><a href="theintermediatecourse.html">The Intermediate Course</a></li>
                                            <li><a href="theadvancedcourse.html">The Advance Course</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="col-xl-2 col-lg-3 col-md-4 col-sm-6"
                                style={{ flex: '1 1 250px', minWidth: '250px' }}
                            >
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-tittle">
                                        <h4>Contact Us</h4>
                                        <ul>
                                            <li><a href="#">09920650996</a></li>
                                            <li><a href="#">kingmakerca@gmail.com</a></li>
                                            <li><a href="#">Mon to Fri (9am to 6pm)</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="col-xl-3 col-lg-4 col-md-5 col-sm-6"
                                style={{ flex: '1 1 250px', minWidth: '250px' }}
                            >
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-logo">
                                        <a href="index.html">
                                            <img
                                                src={logo}
                                                height="75"
                                                width="50"
                                                alt="Logo"
                                            />
                                        </a>
                                    </div>
                                    <div className="footer-tittle">
                                        <div className="footer-pera">
                                            <p className="info1">KING MAKER CHESS ACADEMY</p>
                                        </div>
                                    </div>
                                    <div className="footer-social">
                                        <a href="https://www.facebook.com/kingmakerchessacademy/"><i className="fab fa-facebook-f"></i></a>
                                        <a href="https://goo.gl/maps/qXEVAbHThifRrN4E7"><i className="fab fa-google-plus-g"></i></a>
                                        <a href="https://www.instagram.com/kmca._/?hl=en"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Developer credit - separate row */}
                        <div className="row text-center">
                            <div className="col-lg-12 text-center">
                                <p style={{
                                    color: '#ffffff',
                                    marginTop: '5px',
                                    padding: '5px 0',
                                    fontSize: '16px',
                                    letterSpacing: '1px',
                                    wordSpacing: '2px'
                                }}>
                                    Designed and Developed by HiTech Enterprice
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
